// frontend/src/components/ArtTags/ArtTags.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../services/api";
import ArtTagCard from "./ArtTagCard";
import LoadingSpinner from "../common/LoadingSpinner";
import ErrorMessage from "../common/ErrorMessage";

import "./ArtTags.css";

const ArtTags = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);
  const [artTags, setArtTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCategoryAndTags = async () => {
      try {
        setLoading(true);
        // Load category details
        const categoryData = await api.getCategoryById(categoryId);
        setCategory(categoryData);

        // Load art tags for this category
        const tagsData = await api.getArtTagsByCategory(categoryId);
        setArtTags(tagsData.artTags || tagsData);
        setError(null);
      } catch (err) {
        setError("Failed to load art tags. Please try again later.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadCategoryAndTags();
  }, [categoryId]);

  const handleSelectArtTag = (artTag) => {
    navigate(`/category/${categoryId}/tag/${artTag._id}`, {
      state: {
        categoryName: category?.name,
        tagName: artTag.name,
      },
    });
  };

  const handleBackToCategories = () => {
    navigate("/");
  };

  if (loading) {
    return <LoadingSpinner message="Loading art tags..." />;
  }

  if (error) {
    return (
      <ErrorMessage message={error} onRetry={() => window.location.reload()} />
    );
  }

  return (
    <div className="arttags-main">
      <div className="arttags-content">
        {/* Breadcrumb Navigation */}
        <nav className="arttag-breadcrumb">
          <button
            className="arttag-breadcrumb-link"
            onClick={handleBackToCategories}
            aria-label="Back to categories"
          >
            <svg
              className="arttag-breadcrumb-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            All Categories
          </button>
          <span className="arttag-breadcrumb-separator">/</span>
          <span className="arttag-breadcrumb-current">
            {category?.name || "Loading..."}
          </span>
        </nav>
        <h1 className="arttags-title">
          {category?.name || "Category"} - Art Tags
        </h1>
        <p className="arttags-subtitle">
          Browse artworks by tag in this collection
        </p>

        {artTags.length === 0 ? (
          <div className="arttags-empty">
            No art tags found for this category.
          </div>
        ) : (
          <div className="arttags-grid">
            {artTags.map((artTag) => (
              <ArtTagCard
                key={artTag._id}
                artTag={artTag}
                onClick={() => handleSelectArtTag(artTag)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ArtTags;
